export default {"src":"/_next/static/media/checkmark-black.0b684478.svg","height":28,"width":37,"blurWidth":0,"blurHeight":0};